/**
 * Arena props data — the editable list of 3D model props placed in the arena.
 *
 * Consumed by the client renderer (Arena.buildProps) and collision
 * (propToAabbs). Rewritten by the in-browser map editor on Save.
 */
import type { ArenaProp } from "./arenaGeometry";

export const ARENA_PROPS_DATA: ArenaProp[] = [
  {
    "id": "covered_car",
    "modelUrl": "/models/props/covered_car.glb",
    "x": 0.576,
    "y": 0,
    "z": -11.011,
    "yawDeg": 0,
    "scale": 1.35,
    "sizeX": 1.79,
    "sizeY": 1.41,
    "sizeZ": 4.38,
    "material": "metal",
    "colliders": [
      {
        "cx": 0,
        "cz": 0,
        "sx": 1.79,
        "sz": 2.4,
        "top": 1.41
      },
      {
        "cx": 0,
        "cz": 1.5,
        "sx": 1.79,
        "sz": 0.6,
        "top": 0.9
      },
      {
        "cx": 0,
        "cz": -1.5,
        "sx": 1.79,
        "sz": 0.6,
        "top": 0.9
      },
      {
        "cx": 0,
        "cz": 2,
        "sx": 1.79,
        "sz": 0.4,
        "top": 0.45
      },
      {
        "cx": 0,
        "cz": -2,
        "sx": 1.79,
        "sz": 0.4,
        "top": 0.45
      }
    ]
  },
  {
    "id": "worn_metal_rack",
    "modelUrl": "/models/props/worn_metal_rack.glb",
    "x": -10.662906255011757,
    "y": 0,
    "z": -1.7949999767541884,
    "yawDeg": 0,
    "scale": 1.35,
    "sizeX": 0.915,
    "sizeY": 1.9,
    "sizeZ": 0.6
  },
  {
    "id": "rubber_duck_toy",
    "modelUrl": "/models/props/rubber_duck_toy.glb",
    "x": -10.3,
    "y": 1.28,
    "z": -1.8049985852838084,
    "yawDeg": 0,
    "scale": 1.1,
    "sizeX": 0.214,
    "sizeY": 0.286,
    "sizeZ": 0.3
  },
  {
    "id": "barrel_stove",
    "modelUrl": "/models/props/barrel_stove.glb",
    "x": 3.75,
    "y": 0,
    "z": 9.634259071965147,
    "yawDeg": 0,
    "scale": 2.922,
    "sizeX": 0.593,
    "sizeY": 0.856,
    "sizeZ": 0.593
  },
  {
    "id": "barrel_stove-2",
    "modelUrl": "/models/props/barrel_stove.glb",
    "x": 3.75,
    "y": 0,
    "z": 11.5,
    "yawDeg": 0,
    "scale": 2.922,
    "sizeX": 0.593,
    "sizeY": 0.856,
    "sizeZ": 0.593
  },
  {
    "id": "barrel_stove-3",
    "modelUrl": "/models/props/barrel_stove.glb",
    "x": 3.75,
    "y": 2.51,
    "z": 10.7,
    "yawDeg": 0,
    "scale": 2.922,
    "sizeX": 0.593,
    "sizeY": 0.856,
    "sizeZ": 0.593
  }
];
